export const AGENT_TASK_UPDATE_ACTIONS = {
  BLOCK: "block",
  COMPLETE: "complete",
  FAIL: "fail",
  HEARTBEAT: "heartbeat",
  PROGRESS: "progress",
  RELEASE: "release",
} as const;

export const OPEN_AGENT_TASK_UPDATE_ACTIONS: readonly AgentTaskUpdateAction[] =
  [
    AGENT_TASK_UPDATE_ACTIONS.HEARTBEAT,
    AGENT_TASK_UPDATE_ACTIONS.PROGRESS,
    AGENT_TASK_UPDATE_ACTIONS.RELEASE,
  ];

export type AgentTaskUpdateAction =
  (typeof AGENT_TASK_UPDATE_ACTIONS)[keyof typeof AGENT_TASK_UPDATE_ACTIONS];

export const AGENT_TASK_EVIDENCE_TYPES = [
  "artifact",
  "commit",
  "file",
  "test",
  "url",
] as const;
